import React, {useCallback, useState} from "react";
import handbookService from "../../services/HandbookService"
import {validateFile} from "../../validators/uploadHandbookValidator/uploadHandbookValidator";
import {toast} from "react-toastify";
import {ENGLISH_HANDBOOK_LABEL, SPANISH_HANDBOOK_LABEL} from "../../constants/upload-handbook-constants";
import {HandbookDropzoneContainer} from "./HandbookDropzoneContainer";



export const SpanishHandbookDropzone = ( {handbook, onSetHandbook, onDeleteHandbook, isDisabled, onSetIsDisabled} ) => {

    const handleUploadEnglishHandbook = useCallback((file) => {

        try {
            validateFile(file)
            const formData = new FormData();
            formData.append("file", file);
            onSetIsDisabled(true)
            handbookService.uploadHandbook(SPANISH_HANDBOOK_LABEL, formData)
                .then(response => {

                    onSetHandbook(response.data)
                })
                .catch(() => onSetIsDisabled(false))
        } catch ({message}) {
            toast.error(message);
            toast.clearWaitingQueue()
            onSetIsDisabled(false)
        }
    });

    const onDrop = useCallback(
        (acceptedFiles) => {
            if (!acceptedFiles.length) return;
            acceptedFiles.forEach((file) => handleUploadEnglishHandbook(file));
        },
        [handleUploadEnglishHandbook]
    );

    return <HandbookDropzoneContainer
        handbook={handbook}
        onDrop={onDrop}
        isDisabled={isDisabled || !!handbook?.language}
        onDeleteHandbook={onDeleteHandbook}
        label={SPANISH_HANDBOOK_LABEL}
    />

}